module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dgdlN"))).then(() => parcelRequire('37nVf'));